import React, { Component } from 'react';
import { TableChartCell, TableChartCellTooltip } from './MetricsTableChartCell.styled';

interface ITableChartCellContainerProps {
   maxReached: boolean;
   isCharted: boolean;
   id: string;
   row: string;
   toggleChartedRow;
}

export default class MetricsTableChartCell extends Component<ITableChartCellContainerProps, {}> {
   public render() {
      const { isCharted, maxReached, id, row, toggleChartedRow } = this.props;
      const chartToggleState = isCharted ? 'charted' : maxReached ? 'unchartable' : 'chartable';
      const formattedAnalytic = () => {
         switch (chartToggleState) {
            case 'charted':
               return 'UnchartMetric';
            case 'unchartable':
               return 'UnchartableMetric';
            default:
               return 'ChartMetric';
         }
      };
      return (
         <TableChartCell chartToggleState={chartToggleState} onClick={() => toggleChartedRow(row)} data-analytics={`${formattedAnalytic()}`}>
            <TableChartCellTooltip>
               Maximum of two rows can be charted.
               <br />
               Deselect another chart icon to add this one.
            </TableChartCellTooltip>
         </TableChartCell>
      );
   }
}
